import { api } from "../api";
import axios from "axios";


export const getAnimals = async () => {
    const token = localStorage.getItem('token');
    
    if (!token) {
        console.error('No token found!');
        throw new Error('Not authenticated');
    }
    const res = await axios.get(api+'animaux/',
        {headers: {
            Authorization: 'Bearer '+localStorage.getItem('token'),
            'Content-Type': 'multipart/form-data',
            Accept: "application/json",
        }});
    return res.data;
}
export const getAnimalsE = async () => {
    const res = await axios.get(api+'animals/',
        {headers: {
            Authorization: 'Bearer '+localStorage.getItem('token'),
            'Content-Type': 'multipart/form-data',
            Accept: "application/json",
        }});
    return res.data;
}

export const getAnimalById = async (animalId) => {
    const res = await axios.get(api+'animaux/'+animalId,
        {headers: {
            Authorization: 'Bearer '+localStorage.getItem('token'),
            Accept: "application/json",
        }});
    return res.data;
}
export const getAnimalByIdE = async (animalId) => {
    const res = await axios.get(api+'animals/'+animalId,
        {headers: {
            Authorization: 'Bearer '+localStorage.getItem('token'),
            Accept: "application/json",
        }});
    return res.data;
}
export const getAnimalsByMotherId = async (animalId) => {
    const res = await axios.get(api+'animaux/mother/'+animalId,
        {headers: {
            Authorization: 'Bearer '+localStorage.getItem('token'),
            Accept: "application/json",
        }});
    return res.data;
}


// export const getAnimalsByUser = async (userId) => {
//     const res = await axios.get(api+'animaux/user/'+userId,
//         {headers: {
//             Authorization: 'Bearer '+localStorage.getItem('token'),
//             Accept: "application/json",
//         }});
//     return res.data;
// }

export const addAnimal= async({numero,nom,date_naissance,poids,genre,phase_id,race_id,user_id,mother_id,ferme_id}) => {
    const res = await axios.post(api+'animaux',{
        numero: numero,
        nom: nom,
        date_naissance: date_naissance,
        poids: poids,
        genre: genre,
        phase_id: phase_id,
        race_id: race_id,
        user_id: user_id,
        mother_id: mother_id,
        ferme_id :ferme_id
    },
    {headers: {
            Authorization: 'Bearer '+localStorage.getItem('token'),
            Accept: "application/json",}
    });
    return res.data;
}
export const addAnimalE= async({numero,nom,date_naissance,poids,genre,phase_id,race_id,user_id,mother_id,ferme_id}) => {
    const res = await axios.post(api+'animals',{
        numero: numero,
        nom: nom,
        date_naissance: date_naissance,
        poids: poids,
        genre: genre,
        phase_id: phase_id,
        race_id: race_id,
        user_id: user_id,
        mother_id: mother_id,
        ferme_id : ferme_id
    },
    {headers: {
            Authorization: 'Bearer '+localStorage.getItem('token'),
            Accept: "application/json",}
    });
    return res.data;
}

export const updateAnimal = async (animalId, data) => {
    const res = await axios.put(api + 'animaux/' + animalId, data, {
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('token'),
            Accept: "application/json",
        }
    });

    return res.data;
};

export const updateAnimalE = async (animalId, data) => {
    const res = await axios.put(api + 'animals/' + animalId, data, {
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('token'),
            Accept: "application/json",
        }
    });

    return res.data;
};

export const deleteAnimal = async (animalId) => {
    await axios.delete(api+'animaux/'+animalId, {headers: {
            Authorization: 'Bearer '+localStorage.getItem('token'),
            Accept: "application/json",
}});
}

export const forceDeleteAnimal = async (animalId) => {
    await axios.delete(api+'animaux/force/'+animalId, {headers: {
            Authorization: 'Bearer '+localStorage.getItem('token'),
            Accept: "application/json",
}});
}
